<div class="backpage-wrapper">
  <div class="cred-library-content-creator">
    <ng-container
      *ngIf="
        (!hasCompany && isTechSupportInternalUser) ||
        isInternalAdminUser ||
        (hasCompany && !isTechSupportExternalUser)
      "
    >
      <div class="credential-library-container padding s6 all">
        <div class="header">
          <h1>Credential Library</h1>
        </div>
        <div
          class="cred-item-container"
          *ifPermissions="[
            'Mobile Cred View',
            'Mobile Cred Support',
            'Internal Admin'
          ]"
        >
          <a class="clickable-card" routerLink="/nfc-mobile-credentials">
            <phx-card class="left-side-card padding s6 all">
              <img
                width="75"
                height="75"
                src="../../../assets/Logos/NFCLogo.png"
                alt="credential logo"
              />
              <h2>NFC Mobile Credentials</h2>
            </phx-card>
          </a>
          <div class="view-info-button-container padding s6 all">
            <button
              mat-stroked-button
              class="custom-view-info-button"
              routerLink="/nfc-mobile-credentials"
            >
              View Info
            </button>
          </div>
        </div>
        <div
          class="cred-item-container"
          *ifPermissions="[
            'Engage Transfer',
            'Engage View',
            'Engage Support',
            'Internal Admin'
          ]"
        >
          <a
            class="clickable-card"
            routerLink="/engage-schlage-mobile-access-credentials"
          >
            <phx-card class="left-side-card padding s6 all">
              <img
                width="75"
                height="75"
                src="../../../assets/Logos/engagelogonobg 2.svg"
                alt="engage logo"
              />
              <h2>Schlage Mobile Access Credential with ENGAGE&trade;</h2>
            </phx-card>
          </a>
          <div class="view-info-button-container padding s6 all">
            <button
              mat-stroked-button
              class="custom-view-info-button"
              routerLink="/engage-schlage-mobile-access-credentials"
            >
              View Info
            </button>
          </div>
        </div>
        <div
          class="cred-item-container"
          *ifPermissions="['API View', 'API Support', 'Internal Admin']"
        >
          <a class="clickable-card" routerLink="/BLE-API-credentials">
            <phx-card class="left-side-card padding s6 all">
              <img
                width="75"
                height="75"
                src="../../../assets/Logos/BLE LOGO.svg"
                alt="ble logo"
              />
              <h2>Schlage Mobile Bluetooth Credential API/SDK</h2>
            </phx-card>
          </a>
          <div class="view-info-button-container padding s6 all">
            <button
              mat-stroked-button
              class="custom-view-info-button"
              routerLink="/BLE-API-credentials"
            >
              View Info
            </button>
          </div>
        </div>
        <div class="cred-item-container" *ngIf="!isCredLibraryUser">
          <phx-card class="left-side-card padding s6 all">
            <img
              width="75"
              height="75"
              src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
              alt="orange explanation point"
            />
            <h2>No Active Credential Products Found</h2>
          </phx-card>
          <div class="view-info-button-container padding s6 all"></div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isTechSupportExternalUser">
      <div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to an external role - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        !isInternalUser &&
        isExternalUser &&
        !hasCompany &&
        !isTechSupportExternalUser
      "
    >
      <div class="external-role-error-container padding s6 all">
        <phx-card class="left-side-card padding s6 all">
          <img
            width="75"
            height="75"
            src="../../../assets/weDraw-Images/undraw_notify_re_65on.svg"
            alt="orange explanation point"
          />
          <h2>
            Your account is not tied to a valid company - contact
            <a href="mailto:mobilecredentials@allegion.com"
              >mobilecredentials&#64;allegion.com</a
            >
            and Allegion will help you complete setup.
          </h2>
        </phx-card>
        <div class="view-info-button-container padding s6 all"></div>
      </div>
    </ng-container>
  </div>
</div>
